const strings = {
  EDIT_TIME: 'Redigera en tid',
  EDIT_TIME_INFORMATION:
    'Ställ in en ny start -eller sluttid för att ändra en bokningsbar tid.',
  MANDATORY_FIELD: 'Fältet är oblikatoriskt',
  TIME_UPDATED: 'Passet har uppdaterats',
  INTERNAL_ERROR: 'Ett oväntat fel har uppstått, var god försök igen.'
}

export default strings



// WEBPACK FOOTER //
// ./src/components/containers/EditBookableTimeModal/strings.js